import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy, Renderer2 } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { SfDataService } from '../../services/sf-data.service';
import { Utilities } from '../../services/utilities';
import { IDPReport } from '../../models/IDPReport.model';
import { UserEdit } from '../../models/user-edit.model';
import { Role } from '../../models/role.model';
import { Permission } from '../../models/permission.model';
import { Subject } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
    selector: 'app-sf-icd-report',
    templateUrl: './sf-icd-report.component.html',
    styleUrls: ['./sf-icd-report.component.scss'],
    standalone: false
})
export class SfIcdReportComponent implements OnInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};
  private unlistenClick: (() => void) | null = null;

   
  public iDPReports: any = [
    { label: "US", value: "US" },
    { label: "Canada", value: "Canada" }
  ]



  public iDPICD: any = [
    { label: "Active", value: "Active" },
    { label: "Services Ended", value: "Services Ended" },
    { label: "Pending Onboarding", value: "Pending Onboarding" },
    { label: "Inactive Office (Retrain)", value: "Inactive Office (Retrain)" }
  ]



  public iDPOffice: any = [
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" }
  ]

  // ICD Status defaults to "Active" (applied via dtOptions.searchCols; drives the dropdown display).
  // Location Status has no default — the dropdown starts unselected (all locations shown).
  public selectedICDStatus: string = 'Active';
  public selectedOfficeStatus: string = null;

  public userEdit: UserEdit;
  @Input()
  isViewOnly: boolean;

  @Input()
  isGeneralEditor = false;

  private initialSearchTerm: string | null = null;


  constructor(private alertService: AlertService, private renderer: Renderer2, private sfDataService: SfDataService, private accountService: AccountService, private router: Router, private route: ActivatedRoute, private configurations: ConfigurationService) { }


  ngOnInit() {

    if (!this.canViewCustomers) {
      this.router.navigate(['/']);

    }

    // Capture search term from query params (synchronously)
    this.initialSearchTerm = this.route.snapshot.queryParams['searchTerm'] || null;

    if (!this.isGeneralEditor) {
      //this.alertService.showStickyMessage('Data loading', 'Please wait', MessageSeverity.wait);
      //this.loadCurrentUserData();
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: this.configurations.defaultPageSize,
        lengthMenu: [10, 25, 50, 100],
        processing: true,
        drawCallback: () => {
          // Re-initialize Bootstrap 5 dropdowns after every DataTables draw
          // (required after SPA navigation — Bootstrap registers listeners once at page load)
          document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el: Element) => {
            (window as any).bootstrap?.Dropdown?.getOrCreateInstance(el);
          });
        },
        ajax: (dataTablesParameters: any, callback) => {
          this.sfDataService.getIDPReports().subscribe(resp => {

              // Exclude rows with no ICD Status (rendered as "—") from the report.
              const filtered = Array.isArray(resp)
                ? resp.filter((r: any) => {
                    const status = (r && r.accountStatus != null) ? String(r.accountStatus).trim() : '';
                    return status !== '';
                  })
                : resp;

              callback({
                //recordsTotal: resp.recordsTotal,
                //recordsFiltered: resp.recordsFiltered,
                data: filtered             // <-- see here
              });
           // this.alertService.showStickyMessage('Data loaded', '', MessageSeverity.info);
            $('.dt-buttons').addClass('pull-right');
            });
        },
        columns: [
          {
            title: '',
            data: null,
            orderable: false,
            searchable: false,
            className: 'dt-control',
            defaultContent: ''
          },
          {
          title: 'ICD Company',
          data: 'companyName'
        }, {
          title: 'Owner name',
          data: 'accountOwnerName'
        }

          , {
            title: 'Hub Name',
            data: 'hubName'
          }
          , {
            title: 'TAX ID',
            data: 'accountTaxId'
          }
          //, {
          //  title: 'ICD Status',
          //  data: 'accountStatus'
          //}
          ,{
            title: 'ICD Status',
            data: 'accountStatus',
            render: function (data: any, type: any, full: any) {

              // For filtering/sorting, expose the raw status value (not the HTML
              // dropdown markup) so exact-match searches don't hit "Active" inside
              // the substring "Inactive Office (Retrain)".
              if (type === 'filter' || type === 'sort') {
                return data ?? '';
              }

              if (data == null || data === '' || data === undefined) {

                const displayValue = '—'; // or 'Not Specified'

                return '<div class="dropdown">' +
                  '<button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">' +
                  displayValue +
                  '</button>' +
                  '<ul class="dropdown-menu">' +
                  '<li class="dropdown-divider"></li>' +
                  '<li class="dropdown-item">' +
                  '<a encyrptid="' + full.encyrptID + '" form="campmain" dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm">Campaign Maintenance</a>' +
                  '</li>' +
                  '</ul>' +
                  '</div>';
              }
              else if (data == "Active") {
                return '<div class="dropdown">       <button type = "button" class="btn btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">' + data + '</button><ul class="dropdown-menu" style = "">    <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="campmain"  dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm"> Campaign Maintenance</a> </li> <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="icdoff"   dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm">  ICD Offboarding </a> </li> <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '"   dcode="' + full.distributorCode + '"  form="additionalloc" class="btn btn-warning btn-sm">  Additional Location</a> </li> <li class="dropdown-divider"> </li> <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '"   dcode="' + full.distributorCode + '"  form="hubmaintain" class="btn btn-warning btn-sm">  Hub Maintenance</a> </li>  <li class="dropdown-divider"> </li> <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="inactiveform" dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm"> Inactive Office/Retrain </a> </li></ul> </div>';
              }
              else {
                return '<div class="dropdown">       <button type = "button" class="btn btn-danger dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">' + data + '</button><ul class="dropdown-menu" style = "">    <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="reopenicd"   dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm"> Re-Open ICD</a> </li></ul> </div>';


              }
              return data;
            }
            }

          , {
            title: 'Distributor No',
            data: 'distributorCode'
          }
         
          , {
            title: 'Location  Status',
            data: 'officeStatus',
            render: function (data: any, type: any, full: any) {
              if (data == "Active") {
                return '<div class="dropdown">       <button type = "button" class="btn btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Active</button><ul class="dropdown-menu" style = "">    <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="closeloc" dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm"> Close Location</a> </li> <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" form="moveloc" dcode="' + full.distributorCode + '" class="btn btn-warning btn-sm">  Move Location </a> </li> <li class="dropdown-divider"> </li>  <li class= "dropdown-item"> <a encyrptid="' + full.encyrptID + '" dcode="' + full.distributorCode + '" form="changeoffcinfo" class="btn btn-warning btn-sm">  Change Office Information</a> </li>  <li class="dropdown-divider"> </li> </ul> </div>';
              }
              else {
                //return '<div class="dropdown">       <button type = "button" class="btn btn-danger" data-bs-toggle="dropdown" aria-expanded="false">InActive</button>  </div>';

                return '<div class="dropdown">' +
                  '<button type="button" class="btn btn-danger dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">InActive</button>' +
                  '<ul class="dropdown-menu">' +
                  '<li class="dropdown-item disabled">No actions available</li>' +
                  '</ul>' +
                  '</div>';
                
                
              }
              return data;
            }
          }
          ,
          {
            title: 'Location Type',
            data: 'location_Type',
            
          }

          , {
            title: 'Address',
            data: 'lastKnownAddress'
          }
          , {
            title: 'Address 2',
            data: 'homeAddress2'
          }
          , {
            title: 'City',
            data: 'city'
          }
          , {
            title: 'State',
            data: 'state'
          }
          , {
            title: 'Postal Code',
            data: 'zipCode'
          }
          , {
            title: 'National Consultant',
            data: 'accountNationalConsultantName',
            visible: false
          }
          , {
            title: 'Promoting Owner',
            data: 'accountPromotingOwnerName',
            visible: false
          }

          , {
            title: 'Regional Consultant',
            data: 'accountRegionalConsultantName',
            visible: false
          },
          {
            title: 'Country',
            data: 'accountUsOrCanada',
            visible: false
          },
          {
            title: 'OS',
            data: 'officeStatus', visible: false,
            render: function (data: any, type: any) {
              // The visible Location Status cell shows "Active" only when the raw
              // value is exactly "Active", and "InActive" for everything else.
              // Normalize the filter/sort value to that same binary so an exact
              // "^Active$" / "^InActive$" search always aligns with what's displayed.
              if (type === 'filter' || type === 'sort') {
                return data === 'Active' ? 'Active' : 'InActive';
              }
              return data;
            }
          },
          {
            title: 'Legal Email',
            data: 'legalEmail', visible: false,
          },
          {
            title: 'Mobile Phone',
            data: 'mobilePhone', visible: false,
          },
          {
            title: 'BG Package',
            data: 'eligibilityPackage', visible: false,
          }

        ],
        // Declare the use of the extension in the dom parameter
        dom: 'lBfrtip',
        // Default sort: ICD Company (column 1), ascending — mirrors Tableau.
        order: [[1, 'asc']],
        // Default filter: ICD Status (col 5) = Active. Exact-match regex (regex:true,
        // smart:false) mirrors the dropdown filter method so "Active" never matches
        // "Inactive Office (Retrain)". Location Status is intentionally left unfiltered.
        searchCols: [
          null, null, null, null, null,
          { search: '^Active$', regex: true, smart: false } // 5 = ICD Status
        ],
        responsive: {
          details: false
        },
        intiComplete: function (settings: any, json: any) {
          $('.dt-buttons').addClass('pull-right');
        },
        // Configure the buttons
        buttons: [
          //'columnsToggle',
          //'colvis',
          //'copy',
          //'print',
          { extend: 'excel', title: "ICD", text: 'Export to Excel', className:'btn btn-sm btn-success mb-2 pull-right'},
          //{
          //  text: 'Some button',
          //  key: '1',
          //  action: function (e, dt, node, config) {
          //    alert('Button activated');
          //  }
          //}
        ]
      };
    }
  }


  filterTableByStatus(status: string) {
    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Country column — exact-match so the token matches the whole value only.
    if (status == null) {
      table.column(17).search('').draw();
    }
    else { table.column(17).search(`^${status}$`, true, false).draw(); }

  }


  filterTableByStatusICD(status: string) {
    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Exact-match regex so "Active" does not also match "Inactive Office (Retrain)".
    // Escape regex metacharacters (e.g. the parentheses in "Inactive Office (Retrain)")
    // so the selected value is matched literally.
    if (status == null) {
      table.column(5).search('').draw();
    }
    else {
      const escaped = status.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      table.column(5).search(`^${escaped}$`, true, false).draw();
    }

  }


  filterTableByStatusOffice(status: string) {
    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Update the search text in the "Request Status" column to filter by the clicked status
    if (status == null) {
      table.column(18).search('').draw();
    }
    else {
      table.column(18).search(`^${status}$`, true, false).draw();

    }

  }

  //handleViewClick(encryptID: string) {
  //  // Perform the desired action, such as navigating to a new page
  //  //this.router.navigate(['/icddetail/icdinfo', encryptID]);

  //  //console.log(encryptID);
  //  ////console.log(form);
  //}

  //handleDocumentClick(event: MouseEvent) {
  //  const target = event.target as HTMLElement;
  //  if (target.hasAttribute('encyrptID')) {
  //    const encryptID = target.getAttribute('encyrptID');
  //    this.handleViewClick(encryptID);
  //  }
  //}

  // col index → {field, title} for the 12 main visible columns
  private readonly colMeta = [
    null, // 0 = control
    { field: 'companyName',                   title: 'ICD Company'     },
    { field: 'accountOwnerName',              title: 'Owner Name'      },
    { field: 'hubName',                       title: 'Hub Name'        },
    { field: 'accountTaxId',                  title: 'TAX ID'          },
    { field: 'accountStatus',                 title: 'ICD Status'      },
    { field: 'distributorCode',               title: 'Distributor No'  },
    { field: 'officeStatus',                  title: 'Location Status' },
    { field: 'location_Type',                 title: 'Location Type'   },
    { field: 'lastKnownAddress',              title: 'Address'         },
    { field: 'homeAddress2',                  title: 'Address 2'       },
    { field: 'city',                          title: 'City'            },
    { field: 'state',                         title: 'State'           },
    { field: 'zipCode',                       title: 'Postal Code'     },
  ];

  private buildChildHtml(d: any): string {
    const nc    = d.accountNationalConsultantName || '—';
    const rc    = d.accountRegionalConsultantName || '—';
    const po    = d.accountPromotingOwnerName     || '—';
    const email = d.legalEmail                    || '—';
    const phone = d.mobilePhone                   || '—';
    const bgPkg = d.eligibilityPackage            || '—';

    let html =
      '<div style="padding:8px 12px;background:#f8f9fa;font-size:0.85rem;color:#495057;">' +
        '<div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:4px;">' +
          '<span style="flex:1;min-width:180px;"><strong>NC:</strong> ' + nc + '</span>' +
          '<span style="flex:1;min-width:180px;"><strong>RC:</strong> ' + rc + '</span>' +
          '<span style="flex:1;min-width:180px;"><strong>PO:</strong> ' + po + '</span>' +
        '</div>' +
        '<div style="display:flex;gap:16px;flex-wrap:wrap;">' +
          '<span style="flex:1;min-width:180px;"><strong>Legal Email:</strong> ' + email + '</span>' +
          '<span style="flex:1;min-width:180px;"><strong>Mobile Phone:</strong> ' + phone + '</span>' +
          '<span style="flex:1;min-width:180px;"><strong>BG Package:</strong> ' + bgPkg + '</span>' +
        '</div>';

    // Append any main columns currently hidden by DataTables responsive.
    // Use getComputedStyle at call time — always accurate, no caching issues.
    const collapsed: string[] = [];
    try {
      const ths = document.querySelectorAll('#tbldata thead th');
      for (let i = 1; i <= 13 && i < ths.length; i++) {
        if (window.getComputedStyle(ths[i] as HTMLElement).display === 'none') {
          const meta = this.colMeta[i];
          const value = d[meta.field] || '—';
          collapsed.push('<strong>' + meta.title + ':</strong> ' + value);
        }
      }
    } catch (_) { /* ignore — don't break the child row if DOM lookup fails */ }
    if (collapsed.length > 0) {
      html += '<div style="margin-top:6px;padding-top:6px;border-top:1px solid #dee2e6;display:flex;gap:16px;flex-wrap:wrap;">';
      collapsed.forEach(item => {
        html += '<span style="min-width:180px;">' + item + '</span>';
      });
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  // Tracks data-level row indices that the user has expanded, so we can
  // re-open them after a responsive resize destroys the child row DOM.
  private openRowIndices = new Set<number>();

  ngAfterViewInit(): void {
    // Apply search term from query params if available
    if (this.initialSearchTerm && this.datatableElement && this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dt: any) => {
        // Set search value and redraw table
        dt.search(this.initialSearchTerm);
        dt.draw();
      });
    }

    // When responsive hides/shows columns, refresh any open child rows so the
    // collapsed-column section reflects the new state. getComputedStyle inside
    // buildChildHtml reads live DOM, so the new column visibility is already set
    // by the time this event fires.
    ($('#tbldata') as any).on('responsive-resize.dt', () => {
      if (this.openRowIndices.size === 0) return;
      const dtApi = ($('#tbldata') as any).DataTable();
      this.openRowIndices.forEach(idx => {
        const row = dtApi.row(idx);
        if (!row.node()) return;
        row.child(this.buildChildHtml(row.data()), 'child').show();
        $(row.node()).addClass('parent');
      });
    });

    this.unlistenClick = this.renderer.listen('document', 'click', (event) => {
      if (!(event.target instanceof Element)) return;
      const controlCell = event.target.closest('td.dt-control');
      if (controlCell) {
        const dtApi = ($('#tbldata') as any).DataTable();
        const tr    = $(controlCell).closest('tr');
        const row   = dtApi.row(tr);
        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass('parent');
          this.openRowIndices.delete(row.index());
        } else {
          row.child(this.buildChildHtml(row.data()), 'child').show();
          tr.addClass('parent');
          this.openRowIndices.add(row.index());
        }
        return;
      }

      if (event.target.hasAttribute("encyrptid") && event.target.hasAttribute("form") && event.target.hasAttribute("dcode")) {
        let form = event.target.getAttribute("form");
        let dcode = event.target.getAttribute("dcode");
        let eid = event.target.getAttribute("encyrptid");
        
        if (form == "closeloc") {
          this.router.navigate(["//icddetail/closeloc//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "moveloc") {
          this.router.navigate(["//icddetail/moveloc//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "changeoffcinfo") {
          this.router.navigate(["//icddetail/changeoffinfo//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "campmain") {
          this.router.navigate(["//icddetail/campmain//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "icdoff") {
          this.router.navigate(["//icddetail/closeicd//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "additionalloc") {
          this.router.navigate(["//icddetail/additional//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "reopenicd") {
          this.router.navigate(["//icddetail/reopenicd//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "inactiveform") {
          this.router.navigate(["//icddetail/inactiveoffice//" + eid + "/" + form + "/" + dcode]);
        }
        else if (form == "hubmaintain") {
          this.router.navigate(["//icddetail/hubmaintain//" + eid + "/" + form + "/" + dcode]);
        }
        
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unlistenClick) {
      this.unlistenClick();
      this.unlistenClick = null;
    }
    if (($ as any).fn.DataTable.isDataTable('#tbldata')) {
      ($('#tbldata') as any).DataTable().destroy();
    }
  }

  //ngAfterViewInit(): void {
  //  this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //    dtInstance.columns().every(function () {
  //      const that = this;
  //      $('input', this.footer()).on('keyup change', function () {
  //        if (that.search() !== this['value']) {
  //          that
  //            .search(this['value'])
  //            .draw();
  //        }
  //      });
  //    });
  //  });
      
  //}
  //ngOnDestroy(): void {
  //  this.dtTrigger.unsubscribe();
  //}

  //ngAfterViewInit(): void {
  //  $('.dt-buttons').addClass('pull-right');
  //}

  //rerender(): void {
  //  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //    // Destroy the table first
  //    dtInstance.destroy();
  //    // Call the dtTrigger to rerender again
  //    this.dtTrigger.next(true);
  //  });
  //}

  private loadCurrentUserData() {
    this.alertService.startLoadingMessage();

    this.sfDataService.getIDPReports().subscribe(user => this.onCurrentUserDataLoadSuccessful(user)), error => this.onCurrentUserDataLoadFailed(error);
    
  }

  private onCurrentUserDataLoadSuccessful(iDPReports: IDPReport[]) {
    this.alertService.stopLoadingMessage();
    ////console.log(iDPReports);
    
    this.iDPReports = iDPReports;
    // initiate our data table
    //this.dtTrigger.next(this.dtOptions);
    
  }

  private onCurrentUserDataLoadFailed(error: any) {
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage('Load Error', `Unable to retrieve  data from the server.\r\nErrors: "${Utilities.getHttpResponseMessages(error)}"`,
      MessageSeverity.error, error);
    ////console.log(error);
    this.iDPReports = [];
  }



  get canViewCustomers() {
    return true;// this.accountService.userHasPermission(Permission.viewUsersPermission); // eg. viewCustomersPermission
  }



}
